<template>
    <vx-card v-if="renderForm" :title="this.title" class="po-card">
        <div class="mb-6 vx-row">
            <vs-button @click="handleBack()" class="mt-2 ml-4" color="danger" icon-pack="feather"
                icon="icon-arrow-left">Back</vs-button>
        </div>
        <div class="mb-6 vx-row">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Good Receive</span>
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <CustomMSelect :disabled="this.isDetail" :value="data.grCode" 
                    base-url="/api/wms/v1/wms/gr-reverse/get"
                    label="custom" track-by="custom" :multiple="false" @selected="(v) => {
                    data.grCode = v
                    data.grID = v.id
                    data.gr = v.code_gr
                    data.po = v.code_po
                }"></CustomMSelect>
            </div>
        </div>
        <div class="mb-6 vx-row" v-if="itemList != ''">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Item List</span>
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <div v-for="(item, index) in itemList.purchase_receive_lines" :key="index">
                    <div class="vx-row">
                        <div class="vx-col">
                            <p>{{ item.purchase_order_line.sku_code }}</p>
                        </div>
                        <div class="vx-col">
                            <p>{{ item.purchase_order_line.item_name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="mb-6 vx-row" v-if="false">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Cancel Purchase Order</span>
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <div style="width: fit-content;">
                    <vs-checkbox v-model="data.cancelPo" :disabled="this.page != 'edit'"></vs-checkbox>
                    <div v-if="data.cancelPo" class="mt-3 ml-2 text-danger"><b>All GR related to those PO will be reversed</b></div>
                </div>
            </div>
        </div>        
        <div class="mb-6 vx-row">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Document Date</span>                
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <flat-pickr
                    v-model="data.docDate"
                    :disabled="true"
                    placeholder="Auto generated"
                    style="width: 100%;"
                    :config="config">
                </flat-pickr>
            </div>
        </div>
        <div class="mb-6 vx-row">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Posting Date</span>                
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <flat-pickr
                    v-model="data.postingDate"
                    :disabled="true"
                    placeholder="Set during execute"
                    style="width: 100%;"
                    :config="config2">
                </flat-pickr>
            </div>
        </div>
        <div class="mb-6 vx-row">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Reason</span>                
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <vs-textarea v-model="data.reason" :readonly="this.isDetail" width="100%" />
            </div>
        </div>
        <div class="mb-6 vx-row" v-if="!cisDetail">
            <div class="flex w-full vx-col sm:w-1/6">
                <span>Attachment</span>                
            </div>
            <div class="w-full vx-col sm:w-5/6">
                <input type="file"  
                    ref="attachment" 
                    accept=".jpg,.jpeg,.png,.pdf,.txt,.doc,.docx,.xls,.xlsx"
                    @change="handleChangeAttachment"/>
                <vs-button class="ml-5" color="primary" @click="handleUpload()" type="filled">Upload Attachment</vs-button>
            </div>
        </div>
        <div class="mb-6 vx-row">
            <vs-divider>
                List Attachment
            </vs-divider>
            <vs-list>
                <vs-list-item v-for="(item, index) in data.attachment" :key="index"
                    :title="item.name" class="flex">
                    <div class="flex">
                        <a @click.stop="downloadFileAwsS3(item.path)"><vs-button color="success" type="flat"
                                icon="file_download"></vs-button></a>
                        <vs-button color="danger" @click="handleDeleteAttachment(index, item.id)"
                            type="flat" icon="delete"></vs-button>
                    </div>
                </vs-list-item>
            </vs-list>
        </div>
        <div class="mb-2 vx-row">
            <div style="text-align: center; width: 100%;">
                <vs-button v-if="!cisDetail" class="mb-2 mr-3" @click="handleSubmit">{{page == 'create' ? 'Create' : 'Update'}}</vs-button>
            </div>
        </div>                 
    </vx-card>
</template>

<script>
import CustomMSelect from "./components/CustomMultiSelect.vue";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        CustomMSelect,
        vSelect,
        Datepicker,
        FlatPickr,
    },
    mounted() {
        this.id = this.$route.query.id;
        this.isDetail = (this.$route.query.mode == "detail")
        this.isApproval = (this.$route.query.isApproval == "Approval")
        if (this.isDetail){
            this.title = "Detail Good Receive Reversal"
            this.page = "detail"
        } else if (this.id) {
            this.title = "Edit Good Receive Reversal"
            this.page = "edit"
        } else if (!this.id) {
            this.title = "Good Receive Reversal"
            this.page = "create"
        }        
        if (this.id) {
            this.initData();
        } else {
            this.$vs.loading();
            setTimeout(this.$vs.loading.close, 3200);
        }
    },
    data() {
        return {
            config:{
                dateFormat: "Y-m-d",
                allowInput: true,
                defaultDate: "today",
            },
            config2:{
                dateFormat: "Y-m-d",
                allowInput: true,
            },
            id: null,
            page: null,
            title: "",
            isDetail: false,
            isApproval: false,
            renderForm: true,
            data : {
                id: 0,
                grID: 0,
                grCode: null,
                gr: "",
                po:"",
                cancelPo: false,
                reason:"",
                docDate:"",
                postingDate:"",
                attachment: [],
            },
            itemList : [],
            attachment: null,
            attachmentIDs: [],
        }
    },
    methods: {
        handleSubmit() {
            if (this.data.grCode == null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: 'Information',
                    text: 'GR data is required!',
                    acceptText: 'OK',
                });
            } else if (this.data.reason == "") {
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: 'Information',
                    text: 'Reason is required!',
                    acceptText: 'OK',
                });
            } else {
                this.$vs.dialog({
                    type: "confirm",
                    color: "primary",
                    title: "Confirmation",
                    text: "Are you sure Submit this data",
                    acceptText: "Yes, sure",
                    accept: () => this.acceptConfirm(),
                });
            }
        },
        acceptConfirm(){
            let formData = new FormData();            
            formData.append("data", JSON.stringify(this.data));
            formData.append("attachment_ids", this.attachmentIDs);
            if (this.attachment) {
                this.attachment.forEach(item => {
                    formData.append("files", item);
                });
            }            

            this.$vs.loading()
            let http = this.$http.post("/api/wms/v1/wms/gr-reverse", formData)
            http.then((resp) => {
                console.log(resp)
                if (resp.code == 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });

                    this.$vs.loading.close();
                    this.handleBack()
                } else {
                    this.$vs.loading.close();
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: `Failed`,
                        text: resp.message,
                        acceptText: "OK",
                        cancelButton: false,
                        cancelText: "",
                    });
                    // this.$vs.notify({
                    //     color: "danger",
                    //     title: "Failed",
                    //     text: resp.message,
                    //     position: "top-right",
                    //     iconPack: "feather",
                    //     icon: "icon-x-circle",
                    //     duration: 10000,
                    // });
                }
            })
        },
        handleBack() {
            this.$vs.loading();
            if (!this.isApproval) {
                this.$router.push({
                    path: '/reversal/gr'
                });
            } else {
                this.$router.push({
                    path: '/reversal/gr/approval'
                });
            }
            this.$vs.loading.close();
        },                
        customSku({ code_gr, external_code_gr, code_po, external_code_po }) {
            return `GR Code : ${code_gr} \nGR Code External : ${external_code_gr || ''} \nPO Code : ${code_po} \nPO Code External : ${external_code_po || ''}`;
        },
        initData() {
            this.$vs.loading();
            this.$http
                .get(`/api/wms/v1/wms/gr-reverse/`+this.id, {})
                .then((resp) => {
                    if (resp.code == 200) {                        
                        this.$vs.loading.close();                        
                        var data = resp.data.data[0]
                        var countLine = resp.data.countline
                        var selected = resp.data.option[0]
                        var attc = resp.data.attachment
                        this.data.id = this.id
                        this.data.docDate = this.formatDate(data.request_date)
                        this.data.postingDate = this.formatDate(data.posting_date) != '0001-01-01' ? this.formatDate(data.posting_date) : null
                        this.data.reason = data.reason
                        this.data.grID = data.gr_id
                        this.data.gr = data.code_gr
                        this.data.po = data.po_code
                        this.data.cancelPo = (countLine > 1)
                        this.data.attachment = attc
                        if (typeof selected === 'object' && selected !== null) {
                            selected = {
                                ...selected,
                                custom: this.customSku(selected)
                            };
                        }
                        this.data.grCode = selected
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: `Error`,
                            text: `${resp.code} : ${resp.message}. Do you want to refetch the data?`,
                            accept: this.initData,
                        });
                        console.log(resp)
                    }
                });

        },
        onGrChange(newVal, oldVal) {
            console.log('data.grID old: ', oldVal);
            console.log('data.grID changed: ', newVal);
            this.$vs.loading();
            this.$http.get(`/api/wms/v1/wms/gr-reverse/gr-detail/`+newVal, {})
                .then((resp) => {
                    console.log(resp)
                    if (resp.code == 200) {           
                        this.$vs.loading.close();             
                        this.itemList = resp.data
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: `Error`,
                            text: `${resp.code} : ${resp.message}. Do you want to refetch the data?`,
                            accept: this.initData,
                        });
                        console.log(resp)
                    }
                });
        },
        handleUpload() {
            let doUpload = true
            if (this.data.attachment == null) {
                this.data.attachment = []
            }
            
            var formData = new FormData();
            if (this.attachment.length > 0) {
                Array.from(this.attachment).forEach(item => {
                    if (item.size <= 5000000){
                        formData.append("files", item);
                    } else {
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: `Error`,
                            text: 'Attachment max 5MB',
                        });
                        doUpload = false
                    }
                });
            } else {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: `Error`,
                    text: 'Empty file',
                });
                doUpload = false
            }
            if (doUpload) {
                this.$vs.loading();
                this.$http
                .post(`/api/wms/v1/wms/gr-reverse/upload-file/${this.data.id}`, formData)
                .then(resp => {
                    if (resp.code == 200) {
                        this.$vs.loading.close();
                        if (this.data.id == 0) {
                            this.attachmentIDs.push(resp.data.id)
                        }
                        this.data.attachment.push(resp.data)
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: `Error`,
                            text: `${resp.code} : ${resp.message}`,
                        });
                    }
                });
            }
            this.attachment = []
            this.$refs.attachment.value = null;
        },
        handleChangeAttachment(event) {
            this.attachment = event.target.files ? event.target.files : null;
        },
        handleDeleteAttachment(index, id) {
            var files = Array.from(this.data.attachment)
            files.splice(index, 1)
            this.data.attachment = files;
            if (id) {
                this.deleteFile(id);
            }
        },
        handleDeleteFile(index) {
            var files = Array.from(this.attachment)
            files.splice(index, 1)
            this.attachment = files;
        },
        deleteFile(id) {
            this.$vs.loading();
            this.$http.delete(`/api/wms/v1/wms/gr-reverse/${this.data.id}/attachment/${id}`)
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        // this.form.attachment = resp.data;
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                });
        }
    },
    computed: {
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD');
            };
        },       
        cisDetail() {
            return this.isDetail;
        },
        isEdit() {
            return this.id != undefined;
        }
    },
    watch: {
        'data.grID': 'onGrChange'
    },
}
</script>

<style>
.po-card .vs-input--input.normal{
    text-align: right !important;
}

.customPrompt .vs-dialog footer{
    display: none;
}

.customPrompt .vs-dialog{
    min-width: 620px !important;
}

.vs-dialog-success .vs-dialog footer .vs-button-primary{
    display: none;
}

.vs-dialog {
    min-width: 450px;
}

.vs-dialog-text {
    white-space: pre-line;
}
</style>